// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const GalleryIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
        <path d="M26.25 0H3.75C1.6875 0 0 1.6875 0 3.75V26.25C0 28.3125 1.6875 30 3.75 30H26.25C28.3125 30 30 28.3125 30 26.25V3.75C30 1.6875 28.3125 0 26.25 0ZM28.125 26.25C28.125 27.2813 27.2813 28.125 26.25 28.125H3.75C2.71875 28.125 1.875 27.2813 1.875 26.25V3.75C1.875 2.71875 2.71875 1.875 3.75 1.875H26.25C27.2813 1.875 28.125 2.71875 28.125 3.75V26.25ZM26.25 17.3438V4.6875C26.25 4.17187 25.8281 3.75 25.3125 3.75H4.6875C4.17187 3.75 3.75 4.17187 3.75 4.6875V21.5625C3.75 22.0781 4.17187 22.5 4.6875 22.5H25.3125C25.8281 22.5 26.25 22.0781 26.25 21.5625V17.3438ZM24.7266 5.27344V16.207L21.8906 12.7852C21.7266 12.6211 21.457 12.5977 21.2695 12.75L16.9102 16.2422L11.5781 10.9219C11.4023 10.7461 11.1211 10.7344 10.9453 10.8984L5.27344 16.3125V5.27344H24.7266ZM20.1562 11.25C21.4453 11.25 22.5 10.1953 22.5 8.90625C22.5 7.61719 21.4453 6.5625 20.1562 6.5625C18.8672 6.5625 17.8125 7.61719 17.8125 8.90625C17.8125 10.1953 18.8672 11.25 20.1562 11.25Z" fill="inherit"/>
        </svg>
      )
    }
  </Icon>
);

export default GalleryIcon;
